import { LoginState } from "@core/models/login.interface";
import { createSelector } from "@ngrx/store";

export const selectLoginFeature = (state: { login: LoginState }) => state.login;
export const selectLoginState = createSelector(
  selectLoginFeature,
  (state) => state
);

export const selectLoginAccessToken = createSelector(
  selectLoginFeature,
  (state) => state.userData?.access_token
);

export const selectLoginUserData = createSelector(
  selectLoginFeature,
  (state) => state.userData
);

export const selectLoginLoading = createSelector(
  selectLoginFeature,
  (state) => state.isLoading
);
